export default __webpack_public_path__ + "static/media/INICIO.d4861e61.PNG";